import type { AdminDashboardDependencies } from "../../app/composition/create-admin-dashboard-dependencies";
import type { AdminDashboardLocale } from "../../shared/locale/admin-dashboard-locale";
import { pickAdminDashboardLocaleText } from "../../shared/locale/admin-dashboard-copy";
import { formatAdminAuthModeLabel } from "../../shared/locale/admin-dashboard-status-copy";

export function createOperationContextViewModel(
  dependencies: AdminDashboardDependencies,
  locale: AdminDashboardLocale,
) {
  return {
    title: pickAdminDashboardLocaleText(locale, { en: "Operation context", ko: "운영 정보" }),
    runtimeItems: [
      {
        label: pickAdminDashboardLocaleText(locale, { en: "Environment", ko: "환경" }),
        value: dependencies.runtimeConfig.environmentName,
      },
      {
        label: pickAdminDashboardLocaleText(locale, { en: "Release", ko: "릴리스" }),
        value: dependencies.runtimeConfig.release ?? "dev-local",
      },
      {
        label: pickAdminDashboardLocaleText(locale, { en: "Bundle", ko: "번들" }),
        value: dependencies.runtimeConfig.bundleFingerprint,
      },
    ],
    authModeLabel: formatAdminAuthModeLabel(dependencies.runtimeConfig.authMode, locale),
    roles: dependencies.adminRoles,
  };
}
